/**
 * @description 返回有权限的路由
 */
import _ from 'lodash';
import store from '@/store/index.js';
import NotFound from '@/components/core/core_page/404.vue';

const MENURESOURCE = 1;

/**
 * @description: 页面路径验证
 * @param {String} url 路径
 */
function validateRoute(url) {
    // 去除首尾空白字符
    let trimmedUrl = url.trim();

    // 去除开头的斜杠
    if (trimmedUrl.startsWith('/')) {
        trimmedUrl = trimmedUrl.substring(1);
    }

    // 按照 '/' 分割字符串
    const pathArr = trimmedUrl.split('/');

    return pathArr;
}

/**
 * @description: 根据用户权限生成相应的路由表
 * @param {Array<Object>} menus 权限菜单
 * @param {Object} result 递归结果
 */
function genrateRouterMap(menus, result = []) {
    _.reduce(menus, (routerMap, menu) => {
        const frontUrl = menu.frontUrl;
        if (frontUrl && (frontUrl !== '/')) {
            const arr = validateRoute(frontUrl);
            if (arr === false) {
                // Message.warning(`${_.get(menu, 'resourceName')}路径配置不符合规则！`);
            } else {
                const routeName = arr[arr.length - 1];
                routerMap = _.isArray(routerMap) ? routerMap : [];
                routerMap.push({
                    name: routeName,
                    path: frontUrl,
                    meta: {
                        title: menu.resourceName
                    }
                });
            }
        } else if (menu.resourceType === MENURESOURCE && (menu.subResources && menu.subResources.length > 0)) {
            genrateRouterMap(menu.subResources, routerMap);
        }
        return routerMap;
    }, result);
    return result;
}

/**
 * @description: 获取权限菜单
 */
const getRoutes = () => {
    const menus = store.getters.authority;
    const routerMap = genrateRouterMap(menus);
    return new Promise(resolve => {
        resolve(routerMap);
    });
};

/**
 * @description 取得模块有权限的路由 + 模块路由和组件映射关系 = 需要动态添加的路由
 * @param {Object} modules 引入的路由模块
 */
const generateRoutes = (modules) => {
    const routerMap = modules;
    return getRoutes().then(data => {
        return _.map(data, route => {
            route.component = routerMap[route.name];
            return route;
        });
    });
};

/**
 * @description 注册路由
 * @param {Function} cb 回调函数
 */
const regeisterRoutes = (modules, router, Home) => {
    // import(`./modules.js`).then(modules => {
        // generate routes
        generateRoutes(modules).then(appendRoutes => {
            // register router
            appendRoutes.forEach((item) => {
                if (!item.path.startsWith('http') && item.component) {
                    const routerPrams = {
                        path: '/',
                        component: Home,
                        children: [
                            {
                                path: item.path,
                                name: item.name,
                                component: item.component,
                                meta: {
                                    title: item.meta.resourceName
                                }
                            }
                        ]
                    };
                    router.addRoute(routerPrams);
                }
            });
            router.addRoute(
                {
                    path: '/',
                    component: Home,
                    children: [
                        {
                            path: '*',
                            name: '404',
                            component: NotFound
                        }
                    ]
                }
                );
        });
    // });
};

export {
    regeisterRoutes
};
